import EnterOrderForm from "./Screens/EnterOrderForm";

const EnterOrder = (props: { isIframe?: boolean }) => {
  return <EnterOrderForm isIframe={props.isIframe} />;
};

export default EnterOrder;
